export const ZAPIER_APP_BASE_URL = process.env.ZAPIER_APP_BASE_URL || '';

export const ZAP_EDITOR_URL = 'https://platform.zapier.com/embed/zap-editor';
